<template>
<div>
    <!-- modal -->
    <b-modal id="lawLedesDetailFormModal" centered size="lg" no-close-on-backdrop ref="lawLedesDetailFormModal" :title=" $t('lawLedesDetail.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" @close="clear()">
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col class="mb-1">
                        <validation-provider :name="$t('lawLedesDetail.lawLedes_code_type')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <label for="lawLedes-detail-lawLedes-code-type-input">{{ $t('lawLedesDetail.lawLedes_code_type') }}</label>
                            <b-form-select :state="errors.length > 0 ? false : null" v-model="lawLedesCodeTypeSelect" value-field="id" text-field="name" :options="lawLedesCodeTypeOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider :name="$t('lawLedesDetail.name')" rules="required" v-slot="{ errors }">
                            <label for="lawLedes-detail-name-input">{{ $t('lawLedesDetail.name') }}</label>
                            <b-form-group>
                                <b-form-textarea id="lawLedes-detail-name-input" v-model="name" size="sm" maxlength="250" rows="2" :state="errors.length > 0 ? false : null" />
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider :name="$t('lawLedesDetail.code')" rules="required" v-slot="{ errors }">
                            <label for="lawLedes-detail-code-input">{{ $t('lawLedesDetail.code') }}</label>
                            <b-form-group>
                                <b-form-input id="lawLedes-detail-code-input" v-model="code" size="sm" maxlength="20" :state="errors.length > 0 ? false : null" />
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider :name="$t('lawLedesDetail.tmpt')" rules="required" v-slot="{ errors }">
                            <label for="lawLedes-detail-tmpt-input">{{ $t('lawLedesDetail.tmpt') }}</label>
                            <b-form-group>
                                <b-form-input id="lawLedes-detail-tmpt-input" v-model="tmpt" size="sm" maxlength="50" :state="errors.length > 0 ? false : null" />
                            </b-form-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <label for="lawLedes-detail-description-input">{{ $t('lawLedesDetail.description') }}</label>
                        <b-form-group>
                            <b-form-textarea id="lawLedes-detail-description-input" v-model="description" size="sm" maxlength="1500" rows="3" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawLedesDetailList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            lawLedesCodeTypeSelect: 0,
            lawLedesCodeTypeOption: [],
            code: '',
            tmpt: '',
            name: '',
            description: '',
        }
    },
    methods: {
        clear() {
            this.lawLedesCodeTypeSelect = 0;
            this.code = '';
            this.name = '';
            this.tmpt = '';
            this.description = '';
        },
        showInfo(id, lawLedesId) {
            this.$refs['lawLedesDetailFormModal'].show()
            this.id = id
            this.lawLedesId = lawLedesId
            const data = {
                id: this.id,
                lawLedesId: this.lawLedesId,
            }
            const controller = {
                name: 'LawLedesDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.name = response.data.lawLedesDetail.name
                    this.description = response.data.lawLedesDetail.description
                    this.code = response.data.lawLedesDetail.code
                    this.tmpt = response.data.lawLedesDetail.tmpt
                    this.lawLedesCodeTypeOption = response.data.lawLedesCodeTypeList
                    this.lawLedesCodeTypeOption.splice(0, 0, this.$nullSelected('name'))
                    if (response.data.lawLedesDetail.lawLedesCodeTypeId > 0) {
                        this.lawLedesCodeTypeSelect = response.data.lawLedesDetail.lawLedesCodeTypeId;
                    } else {
                        this.lawLedesCodeTypeSelect = 0
                    }
                } else {
                    this.$bvModal.hide('lawLedesDetailFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                lawLedesCodeTypeId: this.lawLedesCodeTypeSelect,
                lawLedesId: this.lawLedesId,
                name: this.name,
                tmpt: this.tmpt,
                description: this.description,
                code: this.code
            }
            const controller = {
                name: 'LawLedesDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawLedesDetailFormModal')
                            this.getLawLedesDetailList()
                            this.$SaveAlert()
                            this.lawLedesCodeTypeSelect = 0;
                            this.code = '';
                            this.name = '';
                            this.tmpt = '';
                            this.description = '';

                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-template-detail .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
